export default __webpack_public_path__ + "static/media/user_dashboard_4.57f97523.png";